import React, { useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'

import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../../conexoes/api'
import { elipseVerde } from '../../../../utils/alternanciaIcones'
import { formatarMilhar } from '../../../../utils/formatarMilhar'
import PaginacaoTabela from '../../../../utils/paginacaoTabela'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro'
//REDUX

import '../../../../css/painelFaturas/fatPedidos/tabela.css'

let valorLimite = 10
let itensVar = []
let totalPaginas = 0
let totalItens = 10
let contador = 0

export default function InformacoesLogin(props) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [itens, setItens] = useState([])
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)

  const [paginaAtual, setPaginaAtual] = useState(1)
  const [refazerChamadas, setRefazerChamadas] = useState(true)

  useEffect(() => {
    setSpinAtivo(true)
    contador = (paginaAtual - 1) * valorLimite
    async function carregarHistorico() {
      if (refazerChamadas === true) {
        const contagem = await api_gateway.get(
          'm1/consultar/fat_pedido/simcards_pedido?cd_fat_pedido=' +
            props.cd_fat_pedido +
            '&paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&contar=true'
        )

        totalPaginas = Math.ceil(contagem.data.dados[0].CONTADOR / valorLimite)
        totalItens = contagem.data.dados[0].CONTADOR

        setRefazerChamadas(false)
      }
      const linhas = await api_gateway.get(
        'm1/consultar/fat_pedido/simcards_pedido?cd_fat_pedido=' +
          props.cd_fat_pedido +
          '&paginaAtual=' +
          contador +
          '&carregarLimit=' +
          valorLimite +
          '&contar=false'
      )

      inserirData(linhas.data.dados)
    }
    carregarHistorico()
  }, [paginaAtual])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }

      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
    setSpinAtivo(false)
  }

  const colunas = [
    {
      dataField: 'DS_LINHA',
      text: 'Linha',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-detalhamento-cliente-1 ">
            {cell}
          </p>
        )
      }
    },
    {
      dataField: 'DS_ICCID',
      text: 'ICCID',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-detalhamento-cliente-1 ">
            {cell}
          </p>
        )
      }
    },
    {
      dataField: 'DS_PLANO',
      text: 'Plano',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-detalhamento-cliente-1 ">
            {cell}
          </p>
        )
      }
    },
    {
      dataField: 'DS_VALOR_PLANO',
      text: 'Valor',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-detalhamento-cliente-1 ">
            {'R$ ' + formatarMilhar(cell)}
          </p>
        )
      }
    }
  ]

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  return (
    <div className="container-informacoes-login">
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div className="triangulo-navegacao-detalhamento-linha-fatPedido campo-select-triangulo-cor-2" />
      <div className="container-informacoes-login-telas">
        <div className="container-detalhamento-fatPedido fundo-cor-7">
          <Form.Row>
            <Col>
              <img
                className="icone-label-janela nao-selecionavel"
                src={elipseVerde()}
                alt="elipse"
              />
              <Form.Label>
                <div className="fonte-cor-1 label-janela">Linhas do pedido</div>
              </Form.Label>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationProps, paginationTableProps }) => (
                  <div className="container-tabela-informacoes-login">
                    <BootstrapTable
                      classes="tabela-transparente-header-fixo"
                      hover
                      condensed
                      data={itens}
                      keyField="DS_LINHA"
                      columns={colunas}
                      bootstrap4
                      bordered={false}
                      noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                      {...paginationTableProps}
                    />
                    <PaginacaoTabela
                      extrato
                      setPaginaAtual={setPaginaAtual}
                      totalPaginas={totalPaginas}
                      totalItens={totalItens}
                      valorLimite={valorLimite}
                      paginaAtual={paginaAtual}
                      page={paginationProps.page}
                      onPageChange={paginationProps.onPageChange}
                    />
                  </div>
                )}
              </PaginationProvider>
              <div className="itens-exibidos-tabela-extrato fonte-cor-1">
                Mostrando
                <span className="label-tabela-itens-exibidos">
                  {contador + 1}
                </span>
                -
                <span className="label-tabela-itens-exibidos">
                  {contador + valorLimite <= totalItens
                    ? contador + valorLimite
                    : totalItens}
                </span>
                de
                <span className="label-tabela-itens-exibidos">
                  {totalItens}
                </span>
              </div>
            </Col>
          </Form.Row>
        </div>
      </div>
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Por favor tente novamente mais tarde."
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
    </div>
  )
}
